import React, { useMemo } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { IMedication, ISpecialty } from 'types/operation';
import { Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import s from './s.module.less';

interface Props {
    id: number;
    med: IMedication;
    index: number;
    specialties: ISpecialty[];
    onEdit?: (med: IMedication) => void;
    onRemove?: (med: IMedication) => void;
}

const SortableItem: React.FC<Props> = ({ id, med, index, specialties, onEdit, onRemove }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        boxShadow: isDragging ? '0 4px 12px rgba(0,0,0,0.1)' : 'none',
    };

    const specialty = useMemo(() => specialties.find((e) => e.id === med.specialtyId), [specialties, med]);

    return (
        <div ref={setNodeRef} style={style} {...attributes} className={s.card}>
            <div className={s.header}>
                <div className={s.title}>
                    <span className={s.dragHandle} {...listeners}><MenuOutlined /></span>
                    Medication {index + 1}
                </div>
                <div className={s.buttons}>
                    <Button type="text" className={s.removeButton} onClick={() => onRemove?.(med)}>Remove</Button>
                    <Button onClick={() => onEdit?.(med)}>Edit</Button>
                </div>
            </div>
            <div className={s.content}>
                <div className={s.field}>
                    <div className={s.label}>Page link</div>
                    <div className={s.value}>{med?.medicationPageUrl || '-'}</div>
                </div>
                <div className={s.field}>
                    <div className={s.label}>Specialty</div>
                    <div className={s.value}>{specialty?.specialtyName || '-'}</div>
                </div>
                <div className={s.field}>
                    <div className={s.label}>Name</div>
                    <div className={s.value}>{med?.title || '-'}</div>
                </div>
                <div className={s.field}>
                    <div className={s.label}>Subtext</div>
                    <div className={s.value}>{med?.subtext || '-'}</div>
                </div>
                <div className={s.field}>
                    <div className={s.label}>Image</div>
                    {med?.imageUrl ? <img src={med.imageUrl} alt={med.subtext} className={s.image} /> : '-'}
                </div>
            </div>
        </div>
    );
};

export default SortableItem;
